<template>
  <div>
    <v-container>
      <div v-if="searchVisitor">
        <div>
          <TablePatient />
        </div>
        <div v-if="createVisitors == false">
          <SearchVisitors
            ref="searchVisitors"
            :search-title="searchTitle"
            @search="search = $event"
            @resultVisitors="visitors = $event"
            @loading="loading = $event"
            @formVisitors="onFormVisitors($event)"
            @paginationData="paginateData = $event"
            @documentData="fillData($event)"
            :options="options"
          />
          <v-row>
            <v-data-table
              :headers="headers"
              :items="visitors"
              :page="options.page"
              :items-per-page="options.per_page"
              :loading="loading"
              :options.sync="options"
              :server-items-length="paginateData"
              :footer-props="{
                'items-per-page-text': 'Pacientes por Página',
                'items-per-page-options': [10, 25, 50, 100, -1],
              }"
              class="elevation-1"
            >
              <template
                v-slot:[`item.person[0].historical_movement_person.permanence`]="{
                  item,
                }"
              >
                {{
                  formatDateBR(
                    item.person[0].historical_movement_person.permanence
                  )
                }}
              </template>

              <template v-slot:[`item.add`]="{ item }">
                <v-icon
                  color="green"
                  small
                  title="Adicionar"
                  class="mr-2"
                  @click="addPatient(item)"
                  v-if="item.person[0].historical_movement_person"
                >
                  mdi-plus
                </v-icon>
                <v-icon
                  title="Sem saída confirmada"
                  @click="teste(item)"
                  small
                  class="mr-2"
                  color="red"
                  v-if="!item.person[0].historical_movement_person"
                >
                  mdi-lock
                </v-icon>
              </template>
            </v-data-table>
          </v-row>
        </div>
      </div>

      <!-- bendito v-if -->
      <div v-if="createVisitors">
        <h2>Cadastrar Visitante e Acompanhante</h2>
        <v-row>
          <AlertSuccess v-model="displaySuccess" :resource="displaySuccess" />
        </v-row>
        <v-form ref="visitorForm" @submit.prevent="create">
          <v-row style="padding-top: 28px">
            <v-col cols="12" md="5">
              <h4>Tipo de Permanência*:</h4>
              <v-radio-group
                v-model="saveForm.id_person_type"
                row
                :rules="rules.nameRules"
              >
                <v-radio label="Visitante" value="1" />
                <v-radio label="Acompanhante" value="2" />
              </v-radio-group>
            </v-col>
            <v-col v-if="isCounted">
              <h4 style="color: black">
                Visitante(s): {{ getPersonTypeCount.qtyVisitor }}
              </h4>

              <h4 style="color: black">
                Acompanhante(s): {{ getPersonTypeCount.qtyEscort }}
              </h4>

              <h5 style="color: red" v-if="getPersonTypeCount.limit">
                Limite de visitante/acompanhante excedido.*
              </h5>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                dense
                v-model="saveForm.name_person"
                label="Nome*"
                :rules="rules.nameRules"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                outlined
                dense
                v-model="saveForm.social_name"
                label="Nome Social"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                :items="kinships"
                v-model="saveForm.id_kinship"
                item-value="id"
                item-text="kinship_name"
                label="Parentesco*"
                outlined
                dense
                :rules="rules.nameRules"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                outlined
                dense
                v-model="saveForm.phone_number"
                label="Telefone*"
                v-mask="'(##) #####-####'"
                :rules="rules.nameRules"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                outlined
                label="Tipo de documento"
                v-model="saveForm.name_type_document"
                @change="saveForm.document_number = ''"
                class="border__radius-15"
                :items="documentTypeList"
                :disabled="visitorDisabled"
                item-text="type_document_name"
                item-value="type_document_name"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                outlined
                dense
                label="Número do documento*"
                :v-mask="maskDecider"
                v-model="saveForm.document_number"
                :disabled="visitorDisabled"
                :rules="rules.nameRules"
              />
            </v-col>

            <!-- <v-col cols="12" md="4">
              <v-text-field
                outlined
                dense
                label="CNH"
                v-mask="'#########'"
                v-model="saveForm.document_number"
                :disabled="visitorDisabled"
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" md="4">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{}">
                  <v-text-field
                    outlined
                    dense
                    v-model="saveForm.permanence"
                    type="date"
                    label="Data de entrada*"
                    prepend-icon="mdi-calendar"
                    persistent-hint
                    clearable
                    @click:clear="saveForm.permanence = ''"
                  />
                </template>
                <v-date-picker
                  no-title
                  locale="pt-br"
                  v-model="saveForm.permanence"
                  @input="dateMenu = false"
                  @change="formatDate(saveForm.permanence)"
                  :min="dateToday"
                />
              </v-menu>
            </v-col>
            <v-col v-if="saveForm.id_person_type == 2" cols="12" md="4">
              <v-text-field
                outlined
                dense
                v-model="saveForm.final_permanence"
                type="date"
                label="Data final de permanência"
                persistent-hint
                prepend-icon="mdi-calendar"
                clearable
                @click:clear="saveForm.final_permanence = ''"
              />
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="saveForm.observation"
                label="Observação"
                required
              />
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="saveForm.vaccine_observation"
                label="Vacinas*"
                required
              />
            </v-col>
          </v-row>
          <v-btn
            v-if="$store.state.personTypeCount.save"
            style="margin-left: 10px"
            class="float-end primary"
            dark
            type="submit"
          >
            <v-icon size="22" class="icon border__radius-15">
              mdi-arrow-right
            </v-icon>
            Salvar
          </v-btn>
          <v-btn class="float-end dark" dark @click="backVisitor()">
            <v-icon size="22" class="icon border__radius-15">
              mdi-arrow-left
            </v-icon>
            Voltar
          </v-btn>
        </v-form>
      </div>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <AlertError
            class="mb-5"
            v-model="displayError"
            :resource="displayError"
          />
        </v-col>
      </v-row>
    </v-container>
    <Sticker ref="date" :result="resultPerson" />
  </div>
</template>

<script>
import AlertSuccess from "../../alerts/Success-component.vue";
import AlertError from "../../alerts/Error-component.vue";
import SearchVisitors from "./SearchVisitors.vue";
import TablePatient from "../patient/TablePatient-comp.vue";
import Sticker from "../../sticker/Sticker.vue";
import axios from "@/axios";
import { visitorsMixin } from "../../../mixins/visitorsMixin";
export default {
  mixins: [visitorsMixin],
  data() {
    return {
      searchTitle: "Pesquisar Visitante ou Acompanhante",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      paginateData: {},
      totalItems: 0,
      loading: false,
      showTheCode: false,
      dateToday: "",
      resultPerson: "",
      selectObservation: "",
      selectObservationOthersText: false,
      saveForm: {
        //Person - Visitante e acompanhante
        id_document_type: 3,
        name_person: "",
        vaccine_observation: "",
        social_name: "",
        observation: "",
        id_person_type: "",
        id_kinship: "",
        permanence: "",
        final_permanence: "",
        phone_number: "",
        document_number: "",
        name_type_document: "",
        //Paciente
        hospital_patient_name: "",
        functional_unity: "",
        hospital_bed: "",
        attendance_date: "",
        attendance_number: "",
      },
      searchVisitor: true,
      createVisitors: false,
      dateMenu: false,
      date: "",
      search: {},
      visitorDisabled: true,
      visitors: [],
      permanence: "",
      kinship_name: "",
      resultVisitors: {},
      kinships: [],
      headers: [
        {
          text: "Permanência",
          value: "person[0].historical_movement_person.permanence",
        },
        { text: "Nome", value: "person[0].name_person" },
        { text: "Nome Social", value: "person[0].social_name" },
        { text: "CPF", value: "person[0].documents[0].document_number" },
        {
          text: "Paciente",
          value: "hospital_patient[0].hospital_patient_name",
        },
        { text: "Parentesco", value: "person[0].kinship.kinship_name" },
        { text: "Adicionar", value: "add" },
      ],
      displayError: {
        display: false,
        message: [],
      },
      displaySuccess: {
        display: false,
        message: [],
      },
      rules: {
        nameRules: [(v) => !!v || "O campo é obrigatório"],
      },
    };
  },
  components: {
    AlertError,
    AlertSuccess,
    SearchVisitors,
    TablePatient,
    Sticker,
  },
  created() {
    var date = new Date();

    var dia = String(date.getDate()).padStart(2, "0");

    var mes = String(date.getMonth() + 1).padStart(2, "0");

    var ano = date.getFullYear();

    this.dateToday = ano + "-" + mes + "-" + dia;

    axios.get("kinship").then((response) => {
      this.kinships = response.data;
    });

    this.fetchDocumentTypes();
  },

  computed: {
    maskDecider() {
      const documentID = this.saveForm.name_type_document;
      return documentID == 3
        ? "###.###.###-##"
        : documentID == 1
        ? "##.###.###-##"
        : documentID == 2
        ? "#########"
        : "";
    },
  },

  methods: {
    formatDateBR(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString("pt-BR");
    },
    fetchDocumentTypes() {
      axios.get("document-type").then(({ data }) => {
        this.documentTypeList = data?.data ?? data;
      });
    },
    errorForm() {
      this.$swal({
        icon: "warning",
        title: "Existem campos não preenchidos",
        showConfirmButton: true,
      });
    },
    create() {
      if (!this.$refs.visitorForm.validate()) return this.errorForm();
      let today = new Date().toISOString().slice(0, 10);
      let currentDate = new Date(today);
      let searchDate = new Date(this.saveForm.permanence);

      if (!(searchDate >= currentDate)) {
        this.$swal({
          icon: "error",
          title: "Data de entrada precisa ser maior ou igual a data atual.",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      // if (
      //   !(this.saveForm.final_permanence >= this.saveForm.permanence) &&
      //   this.saveForm.id_person_type == 2
      // ) {
      //   this.$swal({
      //     icon: "error",
      //     title:
      //       "Data de saída precisa ser maior ou igual a Data de entrada.",
      //     showConfirmButton: false,
      //     timer: 4500,
      //   });
      //   return;
      // }

      this.formAghuse();
      // const newArray = new Array
      // newArray.push(this.saveForm)

      // this.saveForm.name_type_document
      // if (
      //   this.selectObservation == "Outros" ||
      //   this.selectObservation == "Restrição familiar"
      // ) {
      //   this.saveForm.observation =
      //     this.selectObservation + ": " + this.saveForm.observation;
      // } else {
      //   this.saveForm.observation = this.selectObservation;
      // }
      axios
        .post("/person", this.saveForm)
        .then((response) => {
          //this.$refs.date.dateFormatted(response.data.created_at);
          this.resultPerson = response.data;
          this.$swal({
            icon: "success",
            title: "Cadastro realizado com sucesso.",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.$htmlToPaper("print-sticker");
            this.backVisitor();
          });
        })
        .catch((error) => {
          if (error.detailsDeparture) {
            this.$swal({
              icon: "error",
              title: error.detailsDeparture,
              showConfirmButton: true,
            });
          } else {
            var errors = "";
            for (var e in error) {
              if (error[e][0] !== "CPF inválido.") {
                errors += `${error[e][0]}, `;
              } else {
                errors += error[e][0];
              }
            }
            this.messages(errors);
          }
        });
    },

    fillData(data) {
      this.saveForm.document_number = data.document_number;
      this.saveForm.name_type_document = this.documentTypeList.filter(
        (x) => x.id == data.document_type
      );
      this.saveForm.name_type_document =
        this.saveForm.name_type_document[0].type_document_name;
    },

    formAghuse() {
      this.saveForm.hospital_patient_name =
        this.$store.state.aghusePatient.nome_paciente;
      this.saveForm.functional_unity =
        this.$store.state.aghusePatient.descricao_unidade_funcional;
      this.saveForm.hospital_bed = this.$store.state.aghusePatient.id_leito;
      this.saveForm.attendance_date =
        this.$store.state.aghusePatient.data_hora_internacao;
      this.saveForm.attendance_number =
        this.$store.state.aghusePatient.codigo_do_paciente;

      const routeData = this.$route.query;
      if (routeData.document_type && routeData.document_number) {
        this.saveForm.document_number = routeData.document_number;
        this.saveForm.name_type_document = routeData.document_type;
        this.saveForm.id_document_type = parseInt(routeData.document_type);
      }
      this.$router.replace({ query: {} });
    },
    formatDate(date) {
      this.date = date.split("-").reverse().join("/");
    },

    addPatient(item) {
      this.getPersonTypeReturnCount();
      //criar um objeto para patient
      const { person } = item;

      // const permanence = person[0].historical_movement_person.permanence
      //     ? new Date(person[0].historical_movement_person.permanence)
      //     : null;

      this.saveForm = {
        name_person: person[0].name_person,
        social_name: person[0].social_name,
        observation: person[0].observation,
        id_person_type: person[0].id_person_type,
        id_kinship: person[0].kinship.id,
        permanence: person[0].historical_movement_person.permanence,
        phone_number: person[0].phones[0].phone_number,
        document_number: person[0].documents[0].document_number,
        name_type_document: person[0].documents[0].name_type_document,
        id_document_type: person[0].documents[0].id_document_type,
        vaccine_observation: person[0].vaccine_observation,
      };

      //paciente
      this.formAghuse();
      // Conversão do date-picker
      this.saveForm.permanence = this.saveForm.permanence
        .substring(0, 10)
        .split("/")
        .reverse()
        .join("-");
      this.date = this.saveForm.permanence;
      this.date = this.date.split("-").reverse().join("/");
      this.createVisitors = true;
    },

    messages(errors) {
      if (errors == "CPF inválido.") {
        this.$swal({
          icon: "error",
          title: errors,
          showConfirmButton: false,
          timer: 1000,
        });
      } else if (errors.includes("CPF inválido.")) {
        this.$swal({
          icon: "error",
          title: "CPF inválido.",
          showConfirmButton: false,
          timer: 1000,
        });
        setTimeout(() => {
          errors = errors.replace("CPF inválido.", "");
          this.$swal({
            icon: "error",
            title: `${errors} são campos obrigatórios.`,
            showConfirmButton: false,
            timer: 4000,
          });
        }, 1500);
      } else {
        this.$swal({
          icon: "error",
          title: `${errors} são campos obrigatórios.`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
};
</script>

<style>
.swal2-title {
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
  color: black;
}

.v-data-table {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

.space {
  background-color: rgba(255, 253, 253, 0);
  padding: 10px;
}
</style>
